import React, { KeyboardEvent } from 'react';
import { InnoTag } from '@innomotics/innomotics-build-react-lib';

export interface TagProps {
    text: string | JSX.Element;
    close?: boolean;
    dark?: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

const Tag = ({ close, dark, disabled, text, onClick }: TagProps) => {
    const handleSelect = () => {
        if (onClick && !disabled) {
            onClick();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === ' ') {
            event.preventDefault();
            handleSelect();
        }
    };

    return (
        //<div className={`tag ${disabled ? 'disabled' : ''} ${onClick ? '' : 'display'} ${dark ? 'dark' : ''}`} tabIndex={onClick && !disabled ? 0 : undefined} onClick={handleSelect}
        //    onKeyDown={handleKeyDown}>
        //    <div className='tag-text'>{text}</div>
        //    {close && <Icon type={IconType.CloseSmall} />}
        //</div>
        <InnoTag label={text} tag-type={close && 'removable'} disabled={disabled} onClick={handleSelect} tabIdx={onClick && !disabled ? 0 : undefined}></InnoTag>

    );
};

export default Tag;
